module.exports = __webpack_public_path__ + "static/media/test7.c871581a.jpeg";